import { DockedPanelAction } from "@portal/components/layout/DockedPanel";
import {
	assistantHistoryLabel,
	assistantNewChatLabel,
} from "../../admin/shared/tools/assistant/assistantCopy";
import { useVerniOverlay } from "./VerniOverlay";

/** Verni's conversation controls in the account overlay's header. */
export const VerniHeaderActions = () => {
	const { canStartNew, openConversation, view, setView } = useVerniOverlay();
	const historyOpen = view === "history";

	return (
		<>
			<DockedPanelAction
				icon="clock"
				label={assistantHistoryLabel}
				onClick={() => setView(historyOpen ? "chat" : "history")}
				pressed={historyOpen}
				testId="verni-history-toggle"
				trackingId="verni-history-toggle"
			/>
			<DockedPanelAction
				disabled={!historyOpen && !canStartNew}
				icon="pencil-square"
				label={assistantNewChatLabel}
				onClick={() => openConversation("new")}
				testId="verni-new-conversation"
				trackingId="verni-new-conversation"
			/>
		</>
	);
};
